import React from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { useGetUser } from '../user/useAllUsers';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';
import Activity from './Activity';

const ACTIVITY_JOINED_USER_ACTIVITY_FRAGMENT = gql(`
  fragment ActivityJoinedUser_activity on JoinedUserActivity {
    actedAt
    actor {
      ...useGetUser_user
    }
  }
`);

interface ActivityJoinedUserProps {
  activity: DocumentType<typeof ACTIVITY_JOINED_USER_ACTIVITY_FRAGMENT>;
}

const ActivityJoinedUser = ({ activity }: ActivityJoinedUserProps) => {
  const { actedAt } = activity;

  const getUser = useGetUser();

  if (!activity.actor) {
    return null;
  }

  const actor = getUser(activity.actor);

  return (
    <Activity
      actor={actor}
      actedAt={actedAt}
      action="INVITE_ACCEPT"
      title={
        <>
          <Link to={userPath(actor)}>{actor?.name}</Link> joined your team!
        </>
      }
    />
  );
};

export default ActivityJoinedUser;
